<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
import 'vue-select/dist/vue-select.css';

export default {
  name: 'App',
  data: () => ({
    //
  }),
};
</script>
